// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3UvTl","imageUploader":"EGiftCard_imageUploader__1ZCjR"};